import { Alert, Container } from '@mantine/core';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { takeAccountDeletedNotice } from '@/lib/account-deleted';

/** Shown once on the public home after the account was deleted. */
export function AccountDeletedNotice() {
  const { t } = useTranslation();
  const [shown, setShown] = useState(false);

  // Read in an effect, not during render, so a double render cannot swallow it.
  useEffect(() => {
    if (takeAccountDeletedNotice()) setShown(true);
  }, []);

  if (!shown) return null;
  return (
    <Container size="lg" pt="md">
      <Alert
        role="status"
        color="green"
        withCloseButton
        closeButtonLabel={t('ui.close')}
        onClose={() => setShown(false)}
      >
        {t('welcome.accountDeleted')}
      </Alert>
    </Container>
  );
}
